import React, { ReactElement } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LogoWithClientName.css';

interface LogoWithClientNameProps {
  clientName?: string;
  dfsClientId?: string;
  isLogoClickable?: boolean;
  onClientNameClick?: () => void;
}

const LogoWithClientName: React.FC<LogoWithClientNameProps> = ({
    clientName,
    dfsClientId,
    isLogoClickable = false,
    onClientNameClick,
}) => {
    const navigate = useNavigate();

    const onClientClick = (): void => {
        if (onClientNameClick) {
            onClientNameClick();
        } else if (dfsClientId) {
            navigate(`/client/${dfsClientId}/dashboard`);
        }
    };

    const logoInner: ReactElement = (
        <>
            Zurich
            {' '}
            <strong>Insurance</strong>
        </>
    );

    return (
        <div className="LogoWithClientName">
            {isLogoClickable ? (
                <Link to="/" className="logo-title">
                    {logoInner}
                </Link>
            ) : (
                <div className="logo-title">{logoInner}</div>
            )}

            {clientName && (
                <button type="button" className="client-name" onClick={onClientClick}>
                    {clientName}
                </button>
            )}
        </div>
    );
};

export default LogoWithClientName;
